/* This file is autogenerated, see readme.md for instructions */
import LockSvgIcon from '@bloomreach/banana-theme/icons/lock.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const LockIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <LockSvgIcon />
    </Icon>
  );
});

LockIcon.displayName = 'LockIcon';

export default LockIcon;
